angular.module('app').config([
        'AppRoutesProvider',
        function config(
            AppRoutesProvider
            ) {
            'use strict';

            var appRoutes = {

            };

            AppRoutesProvider.setupAppRoutes(appRoutes);

        }]);
